/* Roots — "Science of Flow" sections: count-up stats, rise-on-scroll, autoplay
   muted videos. Initializes every [data-sof] section on the page once. */
(function () {
  if (window.__rootsSofInit) return;
  window.__rootsSofInit = true;

  function init() {
    var sections = document.querySelectorAll('[data-sof]');
    if (!sections.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (sec) {
      if (sec.__sofDone) return;
      sec.__sofDone = true;

      /* Autoplay muted videos (satisfies autoplay policies) */
      sec.querySelectorAll('video').forEach(function (v) {
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });

      /* Rise-on-scroll entrance */
      var risers = [].slice.call(sec.querySelectorAll('.sof-rise'));
      if (risers.length && !reduce && 'IntersectionObserver' in window) {
        risers.forEach(function (el) { el.classList.add('sof-pre'); });
        var ro = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.remove('sof-pre'); ro.unobserve(e.target); }
          });
        }, { threshold: 0.12 });
        risers.forEach(function (el) { ro.observe(el); });
        // failsafe: never leave content hidden
        setTimeout(function () { risers.forEach(function (el) { el.classList.remove('sof-pre'); }); }, 1400);
      }

      /* Count-up stats */
      var nums = [].slice.call(sec.querySelectorAll('[data-countup]'));
      function runCount(el) {
        var to = parseFloat(el.getAttribute('data-to')) || 0;
        var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
        var pre = el.getAttribute('data-prefix') || '';
        var suf = el.getAttribute('data-suffix') || '';
        var comma = el.hasAttribute('data-comma');
        var dur = 1300, start = null;
        function fmt(n) { return pre + (comma ? Math.round(n).toLocaleString() : n.toFixed(dec)) + suf; }
        function frame(ts) {
          if (start === null) start = ts;
          var t = Math.min(1, (ts - start) / dur);
          var eased = 1 - Math.pow(1 - t, 3);
          el.textContent = fmt(to * eased);
          if (t < 1) requestAnimationFrame(frame); else el.textContent = fmt(to);
        }
        requestAnimationFrame(frame);
      }
      if (nums.length) {
        if (reduce || !('IntersectionObserver' in window)) {
          nums.forEach(function (el) {
            var pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
            var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
            var to0 = parseFloat(el.getAttribute('data-to')) || 0;
            el.textContent = pre + (el.hasAttribute('data-comma') ? Math.round(to0).toLocaleString() : to0.toFixed(dec)) + suf;
          });
        } else {
          var co = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { runCount(e.target); co.unobserve(e.target); }
            });
          }, { threshold: 0.25 });
          nums.forEach(function (el) { co.observe(el); });
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
